// old_wcm_start
export const sendMarcomConversation = (): void => {
    const pixel = new Image();
    pixel.src = 'https://wcm.weborama-tech.ru/fcgi-bin/dispatch.fcgi?a.A=co&a.si=8899&a.cp=39&a.ct=d';
    pixel.width = 1;
    pixel.height = 1;
    pixel.style.display = 'none';
    document.body.appendChild(pixel);
};
// old_wcm_end
